import React from 'react';
import PropTypes from 'prop-types';
import { NavLink, Route, Switch } from 'react-router-dom';
import { createUrl } from '../../utils/createUrl';
import DefaultLayout from '../layout/Default';
import EditProfile from './EditProfile';
import ProfileStatisticsPage from '../Statistics/ProfileStatisticsPage';
import ProfileSettingsUI from '../Settings/ProfileSettingsUI';
import './edit-profile.css';

export default class ProfileAdminPage extends React.Component {
    static propTypes = {
        location: PropTypes.shape({
            search: PropTypes.string,
        }).isRequired,
        match: PropTypes.shape({
            params: PropTypes.shape({
                id: PropTypes.string.isRequired,
            }).isRequired,
        }).isRequired,
    };

    render() {
        const {
            location: { search },
            match: { params },
        } = this.props;
        const profileId = params.id;
        const pathPrefix = params[0] || '';
        return (
            <DefaultLayout>
                <ul className="list list--horizontal u-text-center verticalhr u-pt16 menu">
                    <li className="u-pv16">
                        <NavLink
                            activeClassName="active"
                            className="u-pv16 u-ph32 u-display-inline-block"
                            isActive={(_, location) =>
                                location.pathname.match(/edit$/)
                            }
                            to={createUrl(
                                `/${pathPrefix}company/${profileId}/edit${search}`
                            )}
                        >
                            Bedriftsprofil
                        </NavLink>
                    </li>
                    <li className="u-pv16">
                        <NavLink
                            activeClassName="active"
                            className="u-pv16 u-ph32 u-display-inline-block"
                            isActive={(_, location) =>
                                location.pathname.match(/statistics$/)
                            }
                            to={createUrl(
                                `/${pathPrefix}company/${profileId}/statistics${search}`
                            )}
                        >
                            Din oversikt
                        </NavLink>
                    </li>
                    {search.toLowerCase().includes('orgid') && (
                        <li className="u-pv16">
                            <a
                                className="u-pv16 u-ph32 u-display-inline-block func-new"
                                href={`/job/extended-profile${search}`}
                            >
                                <span>Tydelig Profil</span>
                            </a>
                        </li>
                    )}
                    <Route
                        path={createUrl('/company/:id/:sub')}
                        render={() => (
                            <li className="u-pv16">
                                <NavLink
                                    activeClassName="active"
                                    className="u-pv16 u-ph32 u-display-inline-block"
                                    to={createUrl(
                                        `/company/${profileId}/settings`
                                    )}
                                >
                                    Innstillinger
                                </NavLink>
                            </li>
                        )}
                    />
                </ul>
                <Switch>
                    <Route
                        component={EditProfile}
                        path={createUrl('/(bedrift/)?company/:id/edit')}
                    />
                    <Route
                        component={ProfileStatisticsPage}
                        path={createUrl('/(bedrift/)?company/:id/statistics')}
                    />
                    <Route
                        component={ProfileSettingsUI}
                        path={createUrl('/company/:id/settings')}
                    />
                </Switch>
            </DefaultLayout>
        );
    }
}
